export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: true,
};

export const PageName = '审核值溢出配置列表';
